import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { jqxComboBoxComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcombobox';

@Component({
  selector: 'app-gotx-combo-box',
  templateUrl: './gotx-combo-box.component.html',
  styleUrls: ['./gotx-combo-box.component.css']
})

export class GotxComboBoxComponent implements OnInit {

  @Input('data') data: any[];
  @Input('datafields') datafields: any[];
  @Input('datatype') datatype: string;
  @Input('valueMember') valueMember: string;
  @Input('displayMember') displayMember: string;
  @Input('width') width: string | number;
  @Input('height') height: string | number;
  @Input('displayLabel') displayLabel: boolean;
  @Input('label') label: string;

  @ViewChild('gotxComboBox', { static: false }) gotxComboBox: jqxComboBoxComponent;

  @Output() selectedItem = new EventEmitter<string>();

  error = false;
  errorMessage = "";
  alphaNumericPattern = "^[a-zA-Z0-9]*$";
  upto12 = "^[a-zA-Z0-9]{0,12}$";

  constructor() { }

  source: any;
  dataAdapter: any;

  ngOnInit() {
    this.source =
      {
        localdata: this.data,
        datafields: this.datafields,
        datatype: this.datatype,
        searchMode: 'startswith',
        autoComplete: true
      };

    this.dataAdapter = new jqx.dataAdapter(this.source, { autoBind: true });
  }

  onChange(event: any): void {
    if (event.args && event.args.item)
      this.selectedItem.emit(event.args.item.value);
  }

}
